export function removeEmpty(obj: Record<string, any>): Record<string, any> {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, v]) => !!v)
      .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v])
      .filter(([_, v]) => v === Object(v) ? !!Object.keys(v).length : true)
  );
}